import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'madero-policies',
    imports: [],
    templateUrl: './policies.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './policies.component.scss'
})
export class PoliciesComponent {

}
